import React from 'react';
import { Trans } from 'react-i18next';
import LoginMethodWithTitle from '../../../LoginMethodWithTitle';
import OkIcon from '../../../../../../assets/icons/auth/ok-icon.svg';
import { getEmailProviderInboxUrl } from '../../../../validation';
import s from '../../../../Login.module.scss';
const PasswordResetSent = ({ email, onResendEmail, onBack }) => {
    const inboxUrl = getEmailProviderInboxUrl(email);
    const handleOpenInbox = () => {
        if (!inboxUrl) {
            console.error('Email provider not found');
            return;
        }
        window.open(inboxUrl, '_blank', 'noopener,noreferrer');
    };
    return (React.createElement(LoginMethodWithTitle, { title: React.createElement(Trans, { i18nKey: "passwordResetLinkSent" }), description: React.createElement(Trans, { i18nKey: "checkEmailForResetLink", values: { email } }), icon: OkIcon, onBack: onBack },
        React.createElement("div", { className: s.resetSentActions },
            inboxUrl ? (React.createElement("button", { className: s.openInboxButton, onClick: handleOpenInbox },
                React.createElement(Trans, { i18nKey: "openInbox" }))) : (React.createElement(Trans, { i18nKey: "pleaseCheckYourEmail" })),
            React.createElement("button", { className: s.resendEmailLink, onClick: onResendEmail },
                React.createElement(Trans, { i18nKey: "resendEmail" })))));
};
export default PasswordResetSent;
